import "lightslider"

export default {
  init() {
    // JavaScript to be fired on the about page
  },
  finalize($) {
    if(window.finalize) return false;
    console.log('window.finalize - '+window.finalize)

    //TODO Check double init!
    window.finalize = 1;
    // JavaScript to be fired on the about page, after the init JS
    $('#lightSlider, .lightSliders').lightSlider({
      item        : 1,
      auto        : true,
      loop        : true,
      pause       : 7000,
      gallery     : true,
      thumbItem   : 6,
      slideMargin : 0,
    });

    $('.ct-item__title').each(function() {
      let text = $(this).text();
      $(this).text(text.replace(/\//gi, " / "));
    });

    if(location.hash && location.hash.length) {
      setTimeout(() => {
        document.querySelector(location.hash).scrollIntoView()
      }, 1200);
    }

    // JavaScript to be fired on the about page, after the init JS
    // console.log('about');
    const cell = $(".card"),
      $cardList = $(".card");

    $cardList.each(function() {
      let $this = $(this);
      $this.children(".card__inner").height($this.height());
    });

    $cardList.on('click', function () {
      const thisCell = $(this),
        wrappCells = $(this).parents('.cards');

      $cardList
        .removeClass("is-expanded")
        .addClass("is-collapsed")
        .addClass("is-inactive");
      thisCell
        .removeClass("is-collapsed is-inactive")
        .addClass("is-expanded")
        .children(".card__expander")
        .css(
          "transform",
          "translateX(" +
          (wrappCells.offset().left +
            parseInt(wrappCells.css("paddingLeft"), 10) -
            thisCell.offset().left) +
          "px)"
        );
    })

    $cardList.find(".js-collapser").on('click', function(e) {
      e.stopPropagation();
      $cardList
        .removeClass("is-expanded is-inactive")
        .addClass("is-collapsed");
    })
    /*-------------*/
    //open and close card when clicked on card
    /*cell.find(".js-expander").click(function() {
      const thisCell = $(this).closest(".card"),
        wrappCells = $(this).closest(".cards"),
        naerCells = wrappCells.children(".card");

      if (thisCell.hasClass("is-collapsed")) {
        naerCells
          .not(thisCell)
          .removeClass("is-expanded")
          .addClass("is-collapsed")
          .addClass("is-inactive");
        thisCell
          .removeClass("is-collapsed")
          .addClass("is-expanded")
          .removeClass("is-inactive");
        thisCell
          .children(".card__expander")
          .css(
            "transform",
            "translateX(" +
            (wrappCells.offset().left +
              parseInt(wrappCells.css("paddingLeft"), 10) -
              thisCell.offset().left) +
            "px)"
          );
      } else {
        thisCell.removeClass("is-expanded").addClass("is-collapsed");
        naerCells
          .not(thisCell)
          .removeClass("is-expanded")
          .addClass("is-collapsed")
          .removeClass("is-inactive");
      }
    });*/

    //close card when click on cross
    /*cell.find(".js-collapser").click(function() {
      const thisCell = $(this).closest(".card"),
        wrappCells = $(this).closest(".cards"),
        naerCells = wrappCells.children(".card");

      thisCell.removeClass("is-expanded").addClass("is-collapsed");
      naerCells
        .not(thisCell)
        .removeClass("is-expanded")
        .addClass("is-collapsed")
        .removeClass("is-inactive");
    });*/

  },
};
